import { render } from "./QuickGuide.vue?vue&type=template&id=4fd54cff"
import script from "./QuickGuide.vue?vue&type=script&lang=js"
export * from "./QuickGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__